import { useEffect } from 'react';

const useWillUnmount = (func) => {
  useEffect(() => func, []);
};

export default useWillUnmount;
